import(/* webpackMode: "eager" */ "/home/ubuntu/download/69632a587683ed0014e536c0/desisocio_portfolio/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69632a587683ed0014e536c0/desisocio_portfolio/src/app/homepage/components/CTASection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69632a587683ed0014e536c0/desisocio_portfolio/src/app/homepage/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69632a587683ed0014e536c0/desisocio_portfolio/src/app/homepage/components/PortfolioShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69632a587683ed0014e536c0/desisocio_portfolio/src/app/homepage/components/TestimonialCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69632a587683ed0014e536c0/desisocio_portfolio/src/components/common/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69632a587683ed0014e536c0/desisocio_portfolio/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69632a587683ed0014e536c0/desisocio_portfolio/src/components/common/WhatsAppButton.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/69632a587683ed0014e536c0/desisocio_portfolio/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/69632a587683ed0014e536c0/desisocio_portfolio/src/components/ui/AppImage.tsx");
